import React from 'react';

const PageTitle = ({ pageTitle, subTitle }) => (
  <div data-bem="PageTitle" className="bw-text-header">
    <h2 data-bem="PageTitle__main" className="page-title text-center">
      {pageTitle}
    </h2>
    <p data-bem="PageTitle__sub" className="sub-title text-center">
      {subTitle}
    </p>
  </div>
);

export default PageTitle;
